@import 'styles/variables';
@import 'styles/mixins';

.profileHeader {
  margin-bottom: 48px;
}

.field {
  margin-bottom: 20px;
  input,
  textarea,
  select {
    color: $grey-90;
    @include md-regular;
    min-height: 40px;
  }

  textarea,
  select {
    border: 1px solid $grey-20;
    &:focus {
      border-color: $green-50;
    }
  }
  ::placeholder {
    color: $grey-30;
  }
  label {
    @include sm-regular;
    color: $grey-40;
  }
  .checkboxLabel {
    @include md-regular;
    margin-left: 6px;
    cursor: pointer;
  }
  &.checkbox {
    padding-left: 1px;
  }
}

.coverImageControls {
  align-items: flex-start !important;
  margin-top: 15px;
}

.profileImage {
  bottom: -30%;
}

.inputOverrides {
  select,
  textarea {
    border-radius: 4px;
    padding: 0 16px;
    width: 100%;
  }

  select {
    height: 38.67px;
  }

  textarea {
    padding: 16px;
  }
}

.antdOverride {
  :global .ant-calendar-date {
    height: 32px;
    @include sm-medium;
    line-height: 32px;
    border-radius: 2px;
    color: $almanac-black;
    background-color: $grey-5;
    width: 34px;
    border-color: transparent;
    border-width: 0px;
  }
  :global .ant-calendar-cell {
    padding: 1px 0;
  }
  :global .ant-calendar-today {
    background-color: #def4ff;
    .ant-calendar-date {
      background-color: #def4ff;
      color: $blue-50;
    }
  }
  :global .ant-calendar-selected-date {
    background: $green-50;
    .ant-calendar-date {
      color: $white;
      font-weight: bold;
      background: $green-50;
    }
  }
  :global .ant-calendar-next-month-btn-day {
    background-color: transparent;
    .ant-calendar-date {
      color: $grey-40;
      background-color: transparent;
    }
  }
  :global .ant-calendar-last-month-cell {
    background-color: transparent;
    .ant-calendar-date {
      color: $grey-40;
      background-color: transparent;
    }
  }
  :global .ant-calendar-disabled-cell {
    .ant-calendar-date {
      color: $grey-40;
    }
  }
  :global .ant-calendar-input-wrap {
    height: 40px;
  }
  :global .ant-calendar-selected-day {
    .ant-calendar-date:before {
      background-color: transparent;
    }
  }
}
